"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const ListItem_1 = __importDefault(require("@material-ui/core/ListItem"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const colorManipulator_1 = require("@material-ui/core/styles/colorManipulator");
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const chatFunctions = __importStar(require("../../domain/model/chats"));
const stateFunctions = __importStar(require("../../domain/stateFunctions"));
const gotoChat_1 = require("../../actions/chats/gotoChat");
const date_1 = require("../../formatters/date");
const TextContent_1 = __importDefault(require("../shared/TextContent"));
const messageFunctions_1 = require("../../domain/messageFunctions");
exports.default = react_1.default.memo(MessageSearchMatch);
const useStyles = makeStyles_1.default((theme) => ({
    listItem: {
        "&:hover": {
            backgroundColor: theme.colors.sidePanel.listItemHoverBackgroundColor,
            cursor: "pointer"
        }
    },
    messageSummary: {
        width: "100%"
    },
    messageSnippet: {
        color: colorManipulator_1.alpha(theme.colors.textColor, 0.6),
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: 450
    },
    date: {
        color: colorManipulator_1.alpha(theme.colors.textColor, 0.6),
        float: "right"
    }
}));
function MessageSearchMatch(props) {
    var _a, _b;
    const dispatch = react_redux_1.useDispatch();
    const classes = useStyles();
    const [chat, index] = react_redux_1.useSelector((state) => chatFunctions.getChat(state.chatsState.chats, props.chatId));
    const userDictionary = react_redux_1.useSelector((state) => state.usersState.userDictionary);
    let chatName;
    if (chatFunctions.isDirectChat(chat)) {
        chatName = (_b = (_a = stateFunctions.getUserSummary(chat.them, userDictionary)) === null || _a === void 0 ? void 0 : _a.username) !== null && _b !== void 0 ? _b : "";
    }
    else {
        chatName = chat.subject;
    }
    return (react_1.default.createElement(ListItem_1.default, { onClick: () => dispatch(gotoChat_1.gotoChatByIndex(index, props.message.id)), className: classes.listItem, divider: true },
        react_1.default.createElement("div", { className: classes.messageSummary },
            react_1.default.createElement("div", null,
                react_1.default.createElement(Typography_1.default, { variant: "caption", className: classes.date }, date_1.formatMessageDate(props.message.date)),
                react_1.default.createElement(Typography_1.default, { variant: "body1" }, chatName)),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: classes.messageSnippet },
                    react_1.default.createElement(TextContent_1.default, { text: messageFunctions_1.getContentAsText(props.message.content), variant: "body2", plainText: true }))))));
}
